<app-datepicker
  [minDate]="minDate"
  [maxDate]="maxDate"
  [(ngModel)]="date"
  [disabled]="disabled"
  placeholder="{{ 'questionary.selectDate' | translate }}">
</app-datepicker>
